export const FIREBASE_REDIRECT_ERROR_KEY = 'batikal_firebase_redirect_error'

/**
 * Safari iOS / iPadOS et Android : popups OAuth souvent bloquées ou vides ;
 * utiliser signInWithRedirect + getRedirectResult.
 * On évite `(pointer: coarse)` sur PC tactiles : ça forçait le redirect pour beaucoup de laptops
 * (Surface, etc.) où le popup fonctionne et le retour redirect échoue plus souvent.
 */
export function prefersAuthRedirect(): boolean {
  if (typeof navigator === 'undefined') return false
  const ua = navigator.userAgent || ''
  const isIOSDevice = /iPad|iPhone|iPod/.test(ua)
  const isIPadDesktopMode = navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1
  const isAndroid = /Android/.test(ua)
  return isIOSDevice || isIPadDesktopMode || isAndroid
}
